import { RuleItemInactiveStatuses } from '../queries/types';

interface RuleItem {
  status: string | null;
}

export const isValidationRuleActive = (rule?: RuleItem | null) => {
  return !!rule?.status && !RuleItemInactiveStatuses.includes(rule.status);
};
